/**
 * Moves the first video embed (iframe or <video>) found anywhere in the
 * article body (blocks/_blog-post-content.liquid, inside rte-formatter)
 * into this element - wherever THIS element sits in the template's
 * block_order, e.g. right after the publish date instead of wherever
 * the video happened to get pasted into the rich text editor.
 *
 * Moves the embed's whole containing <p> when that paragraph has no
 * other visible content (the common case: the editor pastes an embed
 * into its own paragraph, sometimes wrapped in a decorative <strong>),
 * so no empty paragraph is left behind at the embed's old spot.
 * Otherwise moves just the iframe/video itself, to avoid dragging along
 * unrelated sibling text in a paragraph that has content besides it.
 */
class BlogFeaturedVideo extends HTMLElement {
  connectedCallback() {
    const embed = document.querySelector('.blog-post-content iframe, .blog-post-content video');
    if (!embed) return;

    const wrapper = this.#findMovableWrapper(embed);
    this.appendChild(wrapper);
  }

  /**
   * @param {Element} embed
   * @returns {Element}
   */
  #findMovableWrapper(embed) {
    let node = embed;
    let paragraph = null;

    while (node.parentElement) {
      if (node.parentElement.tagName === 'P') {
        paragraph = node.parentElement;
        break;
      }
      node = node.parentElement;
    }

    if (paragraph && paragraph.textContent.trim() === '') {
      return paragraph;
    }

    return embed;
  }
}

if (!customElements.get('blog-featured-video')) {
  customElements.define('blog-featured-video', BlogFeaturedVideo);
}
